import React, { useMemo } from 'react';
import StylishNewSelect from 'components/DesignSystems/New/StylishNewSelect';

interface ResourceFiltersProps {
  selectedResourceType: string;
  onResourceTypeChange: (type: string) => void;
  availableResourceTypes: string[];
}

const ResourceFilters: React.FC<ResourceFiltersProps> = ({
  selectedResourceType,
  onResourceTypeChange,
  availableResourceTypes,
}) => {
  const resourceTypeOptions = useMemo(
    () => [
      { value: 'all', label: 'All Resource Types' },
      ...availableResourceTypes.map((type) => ({
        value: type,
        label: type,
      })),
    ],
    [availableResourceTypes]
  );

  // Find the selected option object
  const selectedOption = useMemo(
    () => resourceTypeOptions.find((opt) => opt.value === selectedResourceType),
    [resourceTypeOptions, selectedResourceType]
  );

  return (
    <StylishNewSelect
      options={resourceTypeOptions}
      value={selectedOption}
      onChange={(option) => {
        onResourceTypeChange(option?.value || 'all');
      }}
      placeholder="Filter by Resource Type"
      label="Resource Type"
    />
  );
};

export default ResourceFilters;
